module.exports = __webpack_public_path__ + "img/167.70e9df54.jpg";